import { Grid } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { Typography } from "antd";
import dayjs, { Dayjs } from "dayjs";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import api from "../API/api";
import { WHState } from "../Atom/AtomState";
import AlertComponent from "../CommonComponent/Alert/AlertComponent";
import BarCharts from "../CommonComponent/Charts/BarCharts";
import DoughnutCharts from "../CommonComponent/Charts/DoughutCharts";
import ButtonComponent from "../CommonComponent/Inputs/ButtonComponent";
import Loading from "../CommonComponent/LoadingBar/Loading";
import "../CSS/PageCSS/CustomerResultPage.css";

const { Title } = Typography;

export default function CustomerResultPage() {
  let navigate = useNavigate();
  const WH = useRecoilValue(WHState);
  const [divboxHeight, setdivBoxHeight] = useState<number>(0);
  const [value, setValue] = useState<Dayjs>(dayjs());
  const [ageresult, setAgeResult] = useState<any>([]);
  const [countryresult, setCountryResult] = useState<any>([]);
  const [sexresult, setSexResult] = useState<any>([]);
  const [typeresult, setTypeResult] = useState<any>([]);
  const [alert, setAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSearch = () => {
    const getData = async () => {
      setLoading(true);
      const ageresult = await api.get(
        `/Result/getCustomerAgeResult?yyyy=${value.format("YYYY")}`
      );
      const country = await api.get(
        `/Result/getCustomerCountryResult?yyyy=${value.format("YYYY")}`
      );
      const sex = await api.get(
        `/Result/getCustomerSexResult?yyyy=${value.format("YYYY")}`
      );
      const type = await api.get(
        `/Result/getCustomerTypeResult?yyyy=${value.format("YYYY")}`
      );
      setLoading(false);
      if (
        ageresult != undefined &&
        country != undefined &&
        sex != undefined &&
        type != undefined
      ) {
        setAgeResult(ageresult);
        setCountryResult(country);
        setSexResult(sex);
        setTypeResult(type);
      } else {
        setAlert(true);
        setAlertMessage("데이터 조회에 실패하였습니다.");
      }
    };
    getData();
  };

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const ageresult = await api.get(
        `/Result/getCustomerAgeResult?yyyy=${value.format("YYYY")}`
      );
      const country = await api.get(
        `/Result/getCustomerCountryResult?yyyy=${value.format("YYYY")}`
      );
      const sex = await api.get(
        `/Result/getCustomerSexResult?yyyy=${value.format("YYYY")}`
      );
      const type = await api.get(
        `/Result/getCustomerTypeResult?yyyy=${value.format("YYYY")}`
      );
      setLoading(false);
      if (
        ageresult != undefined &&
        country != undefined &&
        sex != undefined &&
        type != undefined
      ) {
        setAgeResult(ageresult);
        setCountryResult(country);
        setSexResult(sex);
        setTypeResult(type);
      } else {
        setAlert(true);
        setAlertMessage("데이터 조회에 실패하였습니다.");
      }
    };
    getData();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const div = document.getElementById("divbox") as HTMLElement;
      const CustomerConstulResultSearchTextDiv = document.getElementById(
        "CustomerConstulResultSearchTextDiv"
      ) as HTMLElement;
      if (div && CustomerConstulResultSearchTextDiv) {
        setdivBoxHeight(
          div.clientHeight -
            CustomerConstulResultSearchTextDiv.clientHeight -
            20
        );
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  return (
    <div style={{ height: WH.height - 160 }}>
      <Title level={2} className="CustomerResultTitle">
        CustomerResultPage
      </Title>
      <div id="divbox">
        <div
          className="CustomerConstulResultSearchTextDiv"
          id="CustomerConstulResultSearchTextDiv"
        >
          <DatePicker
            label="통계년도"
            value={value}
            onChange={(newValue: any) => setValue(newValue)}
            openTo="year"
            views={["year"]}
            format="YYYY"
            className="CustomerYearSearch"
          />
          <ButtonComponent
            fullWidth
            variant="contained"
            className="CustomerConsultsearchTextDiv_searchButton"
            onClick={handleSearch}
          >
            검색
          </ButtonComponent>
        </div>
        <Grid container spacing={2} style={{ height: divboxHeight }}>
          <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 8 }}>
            <div className="ChartWrapper">
              <Title level={4} className="CustomerResultTitle">
                고객 연령대
              </Title>
              <BarCharts
                columnlabel={ageresult.map((item: any) => item.age_group)}
                data={[ageresult.map((item: any) => item.total_cnt)]}
                label={["인원"]}
              />
            </div>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 4 }}>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 6 }}>
                <div className="ChartWrapper">
                  <Title level={4} className="CustomerResultTitle">
                    국적
                  </Title>
                  <DoughnutCharts
                    columnlabel={countryresult.map((item: any) => item.name)}
                    label={"국적"}
                    data={countryresult.map((item: any) => item.rate)}
                  />
                </div>
              </Grid>
              <Grid size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 6 }}>
                <div className="ChartWrapper">
                  <Title level={4} className="CustomerResultTitle">
                    성별
                  </Title>
                  <DoughnutCharts
                    columnlabel={sexresult.map((item: any) => item.sex)}
                    label={"성별"}
                    data={sexresult.map((item: any) => item.rate)}
                  />
                </div>
              </Grid>
              <Grid size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 6 }}>
                <div className="ChartWrapper">
                  <Title level={4} className="CustomerResultTitle">
                    컨설팅 종류
                  </Title>
                  <DoughnutCharts
                    columnlabel={typeresult.map((item: any) => item.name)}
                    label={"종류"}
                    data={typeresult.map((item: any) => item.rate)}
                  />
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
      {alert && (
        <AlertComponent value={alert} setValue={setAlert} info="error">
          {alertMessage}
        </AlertComponent>
      )}
      {loading && <Loading />}
    </div>
  );
}
